import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import qs from 'query-string';
import ReactApexChart from 'react-apexcharts';
import config from '../../config';

import RegistrationActiveInactiveChartV2 from './RegistrationActiveInactiveChartV2';

// TODO
// Error handle
// loading spinner

class RegistrationActiveInactiveChartV2Show extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            series: [],
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    stackType: '100%',
                    toolbar: {
                        show: true
                      }
                },
                plotOptions: {
                    bar: {
                      horizontal: true,
                    },
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                title: {
                    text: 'Active vs Received Dose / Unregistered'
                },
                colors: ['#1989db','#073863'],
                xaxis: {
                    categories: ['Phase'],
                    labels:{
                        show: true,
                        formatter: function(value) {
                            return value.toString()+"%";
                        },
                    }
                },
                yaxis: [
                    {
                        labels: {
                            show:false
                        },
                        title: {
                            text: "",
                        },
                        tooltip: {
                            enabled: true
                        }
                    }
                    
                ],
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      
      
      };
    }

    async loadOut(){
        // const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let cleanDate=[];
        let cleanTotalCumulativeAACORes=[];
        let cleanTotal1stDose=[];
        let cleanTotal2ndDose=[];
        let cleanTotalBothDose=[];
        let qWhere="1=1";
        let url=config.apiv2.registrationStage;
        let ctRec=0;
        let raceName=[];
        let raceActive=[];
        let raceInactive=[];
        let raceTotal=[];
        let theData=[];
        let totalActive=0;
        let totalInactive=0;


        formData=new FormData();
        formData.append("where",qWhere);
        formData.append("outFields","*");
        formData.append("returnGeometry","false");
        formData.append("orderByFields","Priority_Category");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            _.forEach(qData.features,function(value,key){
                console.log(value.attributes);
                totalActive+=value.attributes.active;
                totalInactive+=value.attributes.inactive;
                // theData.push({
                //     name: value.attributes.Priority_Category,
                //     type: 'bar',
                //     data: [value.attributes.total]
                // });
                // raceName.push(value.attributes.race);
                // raceActive.push(value.attributes.active);
                // raceInactive.push(value.attributes.inactive);
                // raceTotal.push(value.attributes.total);
            });
            // console.log(total)
            theData.push({
                name: "Active",
                type: 'bar',
                data: [totalActive]
            });
            theData.push({
                name: "Received Dose / Unregistered",
                type: 'bar',
                data: [totalInactive]
            });
            // _.forEach(theData,function(value,key){
            //     let percCalc=(value.data[0]/total)*100;
            //     percCalc=Math.round(percCalc * 10) / 10
            //     console.log(percCalc)
            //     value.data=[percCalc];
            // });
            

            this.setState({
                loading:false,
                error:false,
                series: theData,
                options: {
                  ...this.state.options,
                  
                  
                tooltip: {
                    enabled: true,
                    enabledOnSeries: true,
                    shared: true,
                    followCursor: true,
                    intersect: false,
                    inverseOrder: false,
                    fillSeriesColor: false,
                    style: {
                      fontSize: '11px',
                    },
                    onDatasetHover: {
                        highlightDataSeries: true,
                    },
                    y: [{
                        formatter: function(value, timestamp, index) {
                            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        
                    }],
                    marker: {
                        show: true,
                    },
                },
                }
            });
        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }


    render() {
        
            return (
                <Row>
                     {/* style={{height:"100vh",paddingRight:"0",paddingLeft:"0"}} */}
                    <Col>
                        <Card className="text-center h-100">
                            {/* <div id="chart" style={{height:"170px",maxHeight:"200px",paddingRight:"0",paddingLeft:"0"}}>
                                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={'100%'} />
                            </div> */}
                            <RegistrationActiveInactiveChartV2 height="98vh" maxHeight="98vh"></RegistrationActiveInactiveChartV2>
                        </Card>
                    </Col>
                </Row>
            );
        
    }
}

export default RegistrationActiveInactiveChartV2Show;